export const TIME_DELAY = 500;
export const DATE_FORMATE = 'EEEE, dd/MM/YYYY';
export const TIME_FORMATE = 'HHmm';

export const API_STATUS_CODE = {
  SUCESS_CODE: 200,
};

export const API_STATUS_MESSAGES = {
  SUCCESS: 'success',
  PROFILE_STATUS_UPDATE_SUCCESS_MESSAGE: 'User profile updated Successfully',
  PROFILE_PREFRENCE_STATUS_SUCCESS: 'Alert Preference updated successfully',
  PROFILE_STATUS_ADD_FAIL_MESSAGE: 'Failed to add user profile',
  PROFILE_STATUS_UPDATE_FAIL_MESSAGE: 'Failed to update user profile',
  PROFILE_STATUS_ADD_SUCCESS_MESSAGE: 'User profile added Successfully',
  success: {
    DEFAULT_MESSAGE: 'Data saved successfully!',
    PROFILE_STATUS_ADD_SUCCESS_MESSAGE: 'User profile added Successfully',
  },
  error: {
    DEFAULT_MESSAGE: 'Data could not be saved! Please try again.',
    PROFILE_STATUS_ADD_FAIL_MESSAGE: 'Failed to add user profile',
    PROFILE_STATUS_UPDATE_FAIL_MESSAGE: 'Failed to update user profile',
  },
};

export const ERROR_CODE = {
  400: 'Bad Request',
  401: 'Unauthorized',
  404: 'Not Found',
  500: 'Internal Server Error',
  DEFAULT: 'Something Went Wrong! Please Try Again.',
};

export const POPUP = {
  MESSAGES: {
    USER_ALERT_TEXT: ['You have not updated your Region and Route,', 'Please Update Immediately'],
    USER_CONFIRMATION_TEXT: ['Are you sure, you want to continue ?'],
    USER_FAMILIARIZATION_TEXT: ['Do You Want to Browse the Familiarisation Document ?'],
  },
  TYPES: {
    CONFIRMATION: 'CONFIRMATION',
    INFORMATION: 'INFORMATION',
  },
  ACTION: {
    YES: 'YES',
  },
};

export const ALERT_POPUP = {
  MESSAGES: {
    FORECAST_ALERT: ' alert for next 1 hour',
    OBSERVATION_ALERT: ' alert for last 1 hour',
  },
  TYPES: {
    FORECAST: 'Forecast',
    OBSERVATION: 'Observation',
  },
};

export const VALIDATION_REGEX = {
  EMAIL: /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(,[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/,
};
